import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { StartupService } from '@pxl/shared/services';
import { catchError, map, Observable, of, switchMap, timeout } from 'rxjs';

export const startupGuard = (): CanActivateFn => {
    return (route, state): boolean | UrlTree | Observable<boolean | UrlTree> => {
        const startupService = inject(StartupService);
        const router = inject(Router);

        if (startupService.getStatus()) {
            return true;
        }

        if (!navigator.onLine) {
            return router.createUrlTree(['/startup'], { queryParams: { returnUrl: state.url } });
        }

        // quick-check to prevent flickering without wasting too much time
        return startupService.checkApiAvailability().pipe(
            switchMap(() => startupService.loadConfiguration()),
            timeout(250),
            map(() => {
                // go directly into the app
                startupService.markAsInitialized();
                return true;
            }),
            catchError(() => {
                // go to connecting/startup screen
                return of(router.createUrlTree(['/startup'], { queryParams: { returnUrl: state.url } }));
            }),
        );
    };
};
